// Deep links from Home (e.g. /visa-cases?case=12): read the id once when the screen loads,
// then take it out of the address bar so a refresh or closing the record doesn't reopen it.
import { useEffect, useRef } from 'react';

export function takeOpenParam(name) {
  const params = new URLSearchParams(window.location.search);
  const value = params.get(name);
  if (value != null) {
    params.delete(name);
    const rest = params.toString();
    window.history.replaceState(window.history.state, '', `${window.location.pathname}${rest ? `?${rest}` : ''}`);
  }
  return value;
}

// Calls onOpen(id) once if the page was opened with ?<name>=<id>. The ref keeps it to once
// even when StrictMode mounts the screen twice in development.
export function useOpenParam(name, onOpen) {
  const done = useRef(false);
  const handler = useRef(onOpen);
  handler.current = onOpen;
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const value = takeOpenParam(name);
    if (value) handler.current(value);
  }, [name]);
}
